import {useEffect, useState} from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {ID, KTCard} from '../../../../../_metronic/helpers'
import {GetReceptionResponse, Reception} from './core/_models'
import ReceptionPageHeader from './ReceptionPageHeader'
import ReceptionPageList from './ReceptionPageList'
import {CreateAppModal} from './create-app-stepper/CreateAppModal'
import Pagination from '../../../../components/Pagination'
import {getReceptions} from './core/_requests'

const protocolBreadcrumbs: Array<PageLink> = [
  {
    title: 'Receptions',
    path: '/apps/receptions/list',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ReceptionPage = () => {
  const [openFormModal, setOpenFormModal] = useState<boolean>(false)
  const [openDeleteFormModal, setOpenDeleteFormModal] = useState<boolean>(false)
  const [idReceptiono, setIdReceptiono] = useState<ID>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [receptions, setReceptions] = useState<GetReceptionResponse>({
    data: [],
    limite: 10,
    pagina: 1,
    total: 0,
  })
  const [protocol, setReception] = useState<Reception>({})

  const handleList = async (pagina: number = 1, limite: number = 10, query?: string) => {
    setIsLoading(true)

    const recepctionList = await getReceptions(pagina, limite, query)
    setReceptions(recepctionList)

    setIsLoading(false)
  }

  const handleDeleteModal = async (idProt: ID) => {
    setOpenDeleteFormModal(!openDeleteFormModal)

    setIdReceptiono(idProt)
  }

  const handleDelete = async () => {}

  const handleById = async (id: ID) => {
    // const protocol = await getReceptionById(id)

    // setReception(protocol)
    handleFormModal()
  }

  const handleFormModal = (isEmptyModal: boolean = false) => {
    if (isEmptyModal) {
      setReception({})
    }

    setOpenFormModal(!openFormModal)
  }

  useEffect(() => {
    handleList()
  }, [])

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <KTCard>
                <PageTitle breadcrumbs={protocolBreadcrumbs}>Listagem</PageTitle>
                <ReceptionPageHeader handleFormModal={handleFormModal} handleList={handleList} />
                <ReceptionPageList
                  handleFormModal={handleFormModal}
                  handleById={handleById}
                  handleDelete={handleDeleteModal}
                  receptions={receptions}
                  isLoading={isLoading}
                />
                <Pagination handleList={handleList} {...receptions} />
              </KTCard>
              {openFormModal && (
                <CreateAppModal handleClose={handleFormModal} show={openFormModal} />
              )}
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/receptions/list' />} />
    </Routes>
  )
}

export default ReceptionPage
